import ClearButton from './ClearButton.component';

export default ClearButton;
